module.exports = __webpack_public_path__ + "static/journey-dcc3b8e667543917927d9d3e03e0de64.jpg";